import { Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, MenuItem, TextField, DialogActions, Button, Switch, Alert, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import { ErrorsFlattenner } from '../../common/errors-flattenner/errors-flattenner';
import { timestampedMessage } from '../../common/multi-package-scanner/multi-package-scanner';
import CustomDialog from '../../common/custom-dialog/custom-dialog';

interface MarkAsFailedDialogProps {
    onSubmit: (template: string) => Promise<AxiosResponse>
    onClose: () => void;
    failure_reasons: string[];
    setSnackBarResult: (t?: timestampedMessage) => void;
    onSuccess: (reason: string) => void;
}



function MarkAsFailedDialog({ onSubmit, onClose, setSnackBarResult, failure_reasons, onSuccess }: MarkAsFailedDialogProps) {
    const [reason, setReason] = useState<string>("")
    const [useCustomMessage, setUseCustomMessage] = useState(false)
    const [response, setResponse] = useState<AxiosResponse>()
    const [isLoading, setIsLoading] = useState(false)
    const [message, setMessage] = useState("")

    useEffect(() => {
        setReason("")
    }, [useCustomMessage])

    const handleSubmit = async () => {
        setIsLoading(true)
        setSnackBarResult(undefined)
        setResponse(undefined)
        if (!reason) {
            setSnackBarResult({
                content: "Message has no content",
                level: 'error',
                timestamp: Date.now()
            })
            setIsLoading(false);
            return
        }
        try {
            setSnackBarResult(undefined)
            const response = await onSubmit(reason)
            setResponse(response)
            setSnackBarResult({
                content: "Task marked as Failed",
                level: 'success',
                timestamp: Date.now()
            })
            onClose()
            onSuccess(reason)
        } catch (e) {
            const msg = "Failed to mark some (or all) tasks"
            if (axios.isAxiosError(e)) {
                setResponse(e.response)
                setMessage(msg + ": " + e.response?.statusText)
            } else {
                setMessage(msg)
            }

            setSnackBarResult({
                content: msg,
                level: 'error',
                timestamp: Date.now()
            })
        }

        setIsLoading(false)
    }

    return (
        <CustomDialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
            < DialogTitle > Reason of Failure</DialogTitle >
            <DialogContent>
                {
                    isLoading ? <>changing task status... <br /> <CircularProgress /></> : <>
                        {message != '' && (
                            <>
                                <Alert
                                    severity={
                                        response && response.status >= 200 && response.status < 300
                                            ? 'success'
                                            : 'error'
                                    }
                                >
                                    <>
                                        {message}

                                        {response &&
                                            response.status >= 300 &&
                                            <ErrorsFlattenner rawErrors={response.data} />
                                        }
                                    </>
                                </Alert>
                                <br />
                            </>
                        )}

                        {

                            !useCustomMessage && <><FormControl fullWidth margin="normal">
                                <InputLabel>Choose Failure Reason</InputLabel>
                                <Select
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                    label="Choose message template"
                                >
                                    {
                                        failure_reasons.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)
                                    }
                                </Select>
                            </FormControl>
                            </>


                        }
                        <br />
                        <Switch checked={useCustomMessage} onChange={() => { setUseCustomMessage(!useCustomMessage) }} /> Custom Failure Reason
                        <br />
                        {useCustomMessage && (
                            <TextField
                                autoComplete="off"
                                fullWidth
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                margin="normal"
                                label="Start typing .."
                                multiline
                                rows={4}
                                variant="outlined"
                            />
                        )}
                    </>
                }

            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit} disabled={isLoading || reason == undefined || reason.length == 0} color="primary">Send</Button>
            </DialogActions>


        </CustomDialog>
    );
}

export default MarkAsFailedDialog;